/** @format */

//img
import LogoMeli from "../img/LogoMeli.png";
import LogoItesa from "../img/LogoItesa.png";
import LogoOracle from "../img/LogoOracle.png";
import LogoBesedo from "../img/LogoBesedo.png";
import LogoCloudGaia from "../img/LogoCloudGaia.png";
import LogoGlobant from "../img/LogoGlobant.png";
import LogoTiendeo from "../img/LogoTiendeo.png";
import LogoFreebird from "../img/LogoFreebird.png";
import LogoJPMorgan from "../img/LogoJPMorgan.png";
import LogoTehnisys from "../img/LogoTehnisys.png";
import LogoMicrosoft from "../img/LogoMicrosoft.png";
import LogoAccenture from "../img/LogoAccenture.png";
import LogoCognizant from "../img/LogoCognizant.png";
import LogoSantander from "../img/LogoSantander.png";
import LogoUnderscope from "../img/LogoUnderscope.png";
import IBMLogo from "../img/testimoniesJS/logoIBM.png"
import LogoUala from "../img/logoUala.webp"
import LogoGlovo from "../img/logoGlovo.png"
import LogoPWC from "../img/logoPwc.png"
import LogoEtermax from "../img/logoEtermax.png"
import LogoCoca from "../img/logoCoca.svg"
import LogoMural from "../img/LogoMural.png"



const companies = [
	{name: "microsoft", img: LogoMicrosoft, mobileWidth:"5rem", marginTop:"1rem", desktopWidth: "8rem", mobileTop: "", mdMt: "3rem"},
	{name: "meli", img: LogoMeli, mobileWidth:"5rem", desktopWidth: "8rem", mdMt: "3rem"},
	{name: "globant", img: LogoGlobant, mobileWidth:"5rem", marginTop:"1.2rem", desktopWidth: "8rem",  mobileTop: "", mdMt: "3rem"},
	{name: "jp", img: LogoJPMorgan, mobileWidth:"5rem", desktopWidth: "8rem",  mobileTop: "", mdMt: "3rem"},
	{name: "cloudgaia", img: LogoCloudGaia, mobileWidth:"5rem", desktopWidth: "8rem",  mobileTop: "", mdMt: "2rem"},
	{name: "accenture", img: LogoAccenture, mobileWidth:"5rem", desktopWidth: "8rem",  mobileTop: "", mdMt: "2.5rem"},
	{name: "uala", img: LogoUala, mobileWidth:"5rem", marginTop:"1rem", desktopWidth: "8rem",  mobileTop: "0.5rem", mdMt: "4rem"},
	{name: "coca-cola", img: LogoCoca, mobileWidth:"5rem", desktopWidth: "8rem",  mobileTop: "", mdMt: "1.7rem"},
	{name: "mural", img: LogoMural, mobileWidth:"5rem", desktopWidth: "8rem",  mobileTop: "", mdMt: "3rem"},
	{name: "etermax", img: LogoEtermax, mobileWidth:"5rem", desktopWidth: "8rem",  mobileTop: "",  mdMt: "2.5rem"},
	{name: "ibm", img: IBMLogo, mobileWidth:"3rem",marginTop:"1.5rem",  desktopWidth: "5rem",  mobileTop: "0.8rem", mdMt: "4.2rem"}, 
	{name: "oracle", img: LogoOracle, mobileWidth:"5rem", desktopWidth: "8rem",  mobileTop: "1rem", mdMt: "4.2rem"},
	{name: "glovo", img: LogoGlovo, mobileWidth:"5rem", marginTop:"1.2rem", desktopWidth: "8rem",  mobileTop: "0.5rem", mdMt: "3.5rem"},
	{name: "cognizant", img: LogoCognizant, mobileWidth:"5rem", desktopWidth: "8rem",  mobileTop: "0.5rem", mdMt: "4.5rem"},
	{name: "pwc", img: LogoPWC, mobileWidth:"3rem", desktopWidth: "5rem",  mobileTop: "", mdMt: "2.8rem"},
	{name: "santander", img: LogoSantander, mobileWidth:"5rem", desktopWidth: "8rem",  mobileTop: "0.5rem", mdMt: "3.7rem"},
	{name: "besedo", img: LogoBesedo, mobileWidth:"5rem", desktopWidth: "8rem",  mobileTop: "", mdMt: "3rem"},
	{name: "freebird", img: LogoFreebird, mobileWidth:"5rem", desktopWidth: "8rem",  mobileTop: "", mdMt: "3.3rem"},
	{name: "itesa", img: LogoItesa, mobileWidth:"5rem", desktopWidth: "8rem",  mobileTop: "", mdMt: "3rem"},
	{name: "tehnisys", img: LogoTehnisys, mobileWidth:"5rem", desktopWidth: "8rem",  mobileTop: "", mdMt: "3.3rem"},
	{name: "tiendeo", img: LogoTiendeo, mobileWidth:"5rem", desktopWidth: "8rem",  mobileTop: "", mdMt: "2.8rem"},
	{name: "underscope", img: LogoUnderscope, mobileWidth:"5rem", desktopWidth: "8rem",  mobileTop: "", mdMt: "3.5rem"},


];

export default companies;
